import { animate, group, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, OnInit, SimpleChanges } from '@angular/core';
import { SelectableResponseStateEnum } from '../discovery-process.enum';
import { DiscoveryWizardBaseCurrentQuestionComponent } from '../discovery-wizard-base-current-question/discovery-wizard-base-current-question.component';
import { DiscoveryResponse, PossibleResponse } from '../model/discovery-chat.interface';

@Component({
  selector: 'app-discovery-wizard-current-question-gap',
  templateUrl: './discovery-wizard-current-question-gap.component.html',
  styleUrls: ['./discovery-wizard-current-question-gap.component.scss'],
  animations: [
      trigger('slideInOut', [
        state('in', style({
            'opacity': '0.5', 'background-color': '#FA982B'
        })),
        state('out', style({
            'opacity': '1', 'background-color': '#FFFFFF'
        })),
        transition('in => out', [group([
            animate('50ms ease-in-out', style({
              'background-color': '#FFFFFF'
            })),
            animate('50ms ease-in-out', style({
                'opacity': '1'
            }))
        ]
        )]),
        transition('out => in', [group([
            animate('50ms ease-in-out', style({
              'background-color': '#FA982B'
            })),
            animate('50ms ease-in-out', style({
                'opacity': '0.5'
            }))
        ]
        )])
    ]),
  ]
})

export class DiscoveryWizardCurrentQuestionGapComponent extends DiscoveryWizardBaseCurrentQuestionComponent implements OnInit {

  userResponseId : string = "";
  possibleResponses: ResponseGapState[] = [];
  reponsesStateMap: Map<string, SelectableResponseStateEnum>; 
  state = 'out';

  constructor() {
    super();
   }

   ngOnInit(): void {
    super.ngOnInit();
    this.userResponseId = "";
    this.buildResponsesStateArray();
    this.evaluateNextQuestionButton();
    this.nextQuestionAnimation();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.currentQuestion){
      return;
    }

    if (changes.currentQuestion.currentValue != changes.currentQuestion.previousValue && !changes.currentQuestion.firstChange){
      if (this.currentQuestion !== undefined) {
        // this.focusOnElementOnChat(this.topChat);
        this.userResponseId = "";
        this.buildResponsesStateArray();
        this.evaluateNextQuestionButton();
          }

        this.nextQuestionAnimation();
      }
    }

  buildResponsesStateArray(): void{
    if (!this.currentQuestion){
      return;
    }

    this.possibleResponses = [];

    for (let currPossibleResponse of this.currentQuestion.possibleResponses){
        let responseState = new ResponseGapState();
        responseState.responseData = currPossibleResponse;

        if (this.userResponseId == ""){
          // No selected response - all responses are enabled
          responseState.state = SelectableResponseStateEnum.Enabled;
        }
        else if (responseState.responseData.id == this.userResponseId)
        {
          responseState.state = SelectableResponseStateEnum.Selected;
        }
        else if (responseState.responseData.id != this.userResponseId && this.userResponseId != ""){
          responseState.state = SelectableResponseStateEnum.Disabled;
        }
        else{
          responseState.state = SelectableResponseStateEnum.Enabled;
        }

        this.possibleResponses = this.possibleResponses.concat(responseState);
    }
  }

  reponseClicked(resId: string): void{
    this.userResponseId = resId;

    this.buildResponsesStateArray();
    this.evaluateNextQuestionButton();
  }

  evaluateNextQuestionButton(): void{
    this.isAllResponsesAnswered = false;

    if (this.possibleResponses.length == 0){
      // no possible answers, allow the user to continue
      this.isAllResponsesAnswered = true;
      return;
    }
  
    if (this.userResponseId != ""){
      this.isAllResponsesAnswered = true;
    }
  }
    cancelProcess(): void{
      this.cancelProcessEvent.emit();
    }

    submitResponse(): void{
      if (!this.currentQuestion){
        this.sendQuestionResponseEvent.emit([]);
        return;
      }
  
      let responses : DiscoveryResponse[] = [];
        
      let userResponse = {questionId:this.currentQuestion.id, responseId:this.userResponseId};
      
      responses= [userResponse];
      this.sendQuestionResponseEvent.emit(responses);
   }

   async nextQuestionAnimation() {
    this.state = 'in';
    await this.utilsService.delay(0.2);  
    this.state = 'out';
  }   
}

export class ResponseGapState{
  responseData: PossibleResponse;
  state: SelectableResponseStateEnum;
}
